export default __webpack_public_path__ + "static/media/beraksi-phone2.bb83b361.png";